import React from 'react';

import { Show, SimpleShowLayout } from 'components/detail';
import { TextField, ChoiceDisplayField, ImageField } from 'components/field';

import * as urls from './urls';
import {
  HIGHLIGHT_NAME,
  NEWS_STATUS_NAME,
  HEADLINE_NAME,
  NEWS_CREATE_CATEGORY_NAMES,
} from "./utils";


export const NewsDetail = (props) => {
  return (
    <Show detailBackendPath={urls.newsDetailBackendPath} {...props}>
      <SimpleShowLayout>
        <TextField source="id" label="ID"/>
        <TextField source="caption" label="Caption"/>
        <TextField source="caption_en" label="Caption English"/>
        <TextField source="url" label="Custom URL"/>
        <TextField source="description" label="Description"/>
        <TextField source="description_en" label="Description English"/>
        <ChoiceDisplayField source="category" label="Category" choiceName={NEWS_CREATE_CATEGORY_NAMES}/>
        <TextField source="last_updated_by" label="Last Updated By"/>
        <TextField source="created_at" label="Create Time"/>
        <TextField source="updated_at" label="Update Time"/>
        <TextField source="published_at" label="Publish Time"/>
        <ChoiceDisplayField source="status" label="Status" choiceName={NEWS_STATUS_NAME}/>
        <ChoiceDisplayField source="highlight" label="Highlight" choiceName={HIGHLIGHT_NAME}/>
        <ChoiceDisplayField source="headline" label="Headline" choiceName={HEADLINE_NAME}/>
        <TextField source="viewed" label="Viewed"/>
        <TextField source="liked" label="Shared"/>
        <TextField source="shared" label="Liked"/>
        <TextField source="ocha_web_url" label="Ocha Web URL"/>
        <ImageField addLabel={true} source="cover_photo" label="Cover Photo"/>
        <ImageField addLabel={true} source="cover_photo_en" label="Cover Photo English"/>
      </SimpleShowLayout>
    </Show>
  )
};

export const NewsBannerDetail = (props) => {
  return (
    <Show detailBackendPath={urls.newsBannerDetailBackendPath} {...props}>
      <SimpleShowLayout>
        <TextField source="id" label="ID"/>
        <TextField source="caption" label="Caption"/>
        <TextField source="last_updated_by" label="Last Updated By"/>
        <TextField source="created_at" label="Create Time"/>
        <TextField source="updated_at" label="Update Time"/>
        <TextField source="published_at" label="Publish Time"/>
        <ChoiceDisplayField source="status" label="Status" choiceName={NEWS_STATUS_NAME}/>
        <TextField source="viewed" label="Viewed"/>
        <TextField source="ocha_web_url" label="Ocha Web URL"/>
      </SimpleShowLayout>
    </Show>
  )
};



// WEBPACK FOOTER //
// ./src/routes/news/NewsDetail.js